module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA20.b9d3b012.jpg";